import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { Observable } from 'rxjs';
import { SegmentAutocompleteComponent } from './segment-autocomplete.component';
import { Segment } from '../../domain/supply-marketplace.model';
import { ActiveArchivedColorMap } from 'src/app/shared/enums/active-archived.enum';
import { SupplyMarketplaceService } from '../../services/supply-marketplace.service';

@Component({
  selector: 'ctv-segment-autocomplete-chips',
  template: `
      <ctv-segment-autocomplete #sc
                                  (segmentSelected)="onItemSelected($event)"
                                  [formFieldClass]="formFieldClass"
                                  [required]="required"
                                  [label]="placeholder"
                                  [floatLabel]="floatLabel"
                                  [formFieldAppearance]="formFieldAppearance ? formFieldAppearance : ''">
      </ctv-segment-autocomplete>
      <mat-chip-list #chipList class="mt-n3" [ngClass]="[stacked ? 'mat-chip-list-stacked' : '', items.length > 0 ? 'mb-4' : '']" [hidden]="items.length < 1">
        <mat-basic-chip *ngFor="let item of items"
                        (removed)="remove(item)">
        <i class="fas fa-circle mr-1 ml-0" ngClass="text-{{SegmentStatusColorMap[item.status]}}"></i>
          {{item.name}}
          <i class="fas fa-times-circle text-danger hand" matChipRemove></i>
        </mat-basic-chip>
      </mat-chip-list>
  `,
})
export class SegmentAutocompleteChipsComponent implements OnInit {
  @ViewChild(SegmentAutocompleteComponent, {static: true}) sc: SegmentAutocompleteComponent;

  /** Pass clearFilterItems = new Subject<void>(); as Observable into it and then call clearFilterItems.next() to clear all the items*/
  @Input() clearItems: Observable<void>;
  @Input() public placeholder: string;
  @Input() public stacked: false;
  @Input() public segmentIds: string[];
  @Input() public floatLabel: string;
  @Input() public formFieldClass: string;
  @Input() public formFieldAppearance: string;
  @Input() preselectedValues: Segment[];
  @Input() updateSelection: Observable<void>;
  @Input() required = false;
  @Output() segmentSelectionChange = new EventEmitter<Segment[]>();

  items: Segment[] = [];

  SegmentStatusColorMap = ActiveArchivedColorMap;

  constructor(private service: SupplyMarketplaceService) {
  }

  ngOnInit(): void {
    if (this.segmentIds && this.segmentIds.length) {
      //On parent component reload if there is single preselected item, it will actually be passed as string instead of a list
      if (typeof this.segmentIds === 'string') {
        this.segmentIds = [this.segmentIds];
      }
      //Fetch only preselected segment
      this.service.getSegments({ids: this.segmentIds} as any).subscribe(segments => {
        segments.content.map(segment => {this.items.push(segment);});
        this.sc.updateFilteredSegments(this.items);
      });
    }
    this.updateSelection?.subscribe(() => {
      if (this.segmentIds?.length) {
        this.service.getSegments({ids: this.segmentIds} as any).subscribe(segments => {
          this.items =  segments.content;
          this.sc.updateFilteredSegments(this.items);
        });
      }
    });
    this.clearItems?.subscribe(() => this.clearFilter());
  }


  onItemSelected($event: Segment) {
    if ($event) {
      this.items.push($event);
      this.segmentSelectionChange.emit(this.items);
      this.sc.resetInput();
      this.sc.updateFilteredSegments(this.items);
    }
  }

  remove(segment: Segment) {
    this.items.splice(this.items.indexOf(segment), 1);
    this.segmentSelectionChange.emit(this.items);
    this.sc.updateFilteredSegments(this.items);
  }

  /** Clear all items from filter. */
  clearFilter(){
    this.items = [];
    this.sc.updateFilteredSegments(this.items);
  }

  disableFilter(disable: boolean) {
    if (disable) {
      this.sc.disable();
    }
    else {
      this.sc.enable();
    }
  }
}
